import Dialog from './Dialog.component';

export default Dialog;
